import React from 'react';

export const LogoYoutube = () => (
    <svg
        width="23px"
        height="16px"
        viewBox="0 0 23 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <title>Youtube icon</title>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-980.000000, -613.000000)" fill="#FFFFFF">
                <g>
                    <g transform="translate(120.000000, 593.000000)">
                        <g transform="translate(812.000000, 12.000000)">
                            <g transform="translate(44.000000, 0.000000)">
                                <g>
                                    <g transform="translate(4.666667, 7.333333)">
                                        <path
                                            d="M21.8818354,3.40324414 C22.2698202,5.08964478 22.2666023,6.9305038 22.2666023,8.66678162 C22.2666023,10.4028296 22.2652232,12.2434588 21.8770086,13.9298594 C21.6044079,15.1140404 20.6355952,15.9876957 19.4702618,16.11802 C16.7095479,16.426477 13.9152761,16.428086 11.1324967,16.426477 C8.35017699,16.428086 5.5552156,16.426477 2.79427184,16.11802 C1.62824889,15.9874658 0.660125748,15.1138106 0.387984771,13.9298594 C0,12.2436886 0,10.4030594 0,8.66678162 C0,6.9305038 0.00436712716,5.08964478 0.392351898,3.40324414 C0.664952573,2.21906314 1.63284586,1.34540785 2.79817927,1.21508359 C5.55935288,0.906856348 8.35454411,0.905247406 11.1368638,0.906856348 C13.9187238,0.905247406 16.7134554,0.906856348 19.474629,1.21508359 C20.6406519,1.34540785 21.6092348,2.21906314 21.8818354,3.40324414 Z M8.26693572,12.4133339 C10.6789477,11.1625742 13.0698716,9.92329587 15.4832895,8.67159895 C13.0623736,7.40865503 10.6726213,6.16187868 8.26693572,4.90666707 C8.26693572,7.41779322 8.26693572,9.90244206 8.26693572,12.4133339 Z"
                                            id="Combined-Shape"
                                            fillRule="nonzero"
                                        />
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
